<template>
  <DialogTemplate :show-controls="true" class="dialog" icon-header="settings">
    <template #header> {{ $t('library.title') }} </template>
    <div class="settings-wrapper">
      <ul class="scrollable">
        <DialogLibrarySettingsItem
          v-for="{ item, selected } in items"
          :id="item.id"
          :key="item.id"
          :name="item.name"
          :type="item.type"
          :class="{ hidden: selected }"
          @select="handleSelect"
        />
      </ul>
    </div>

    <template #footer>
      <div class="actions">
        <ButtonBase
          :class="{ hidden: select.length === 0 }"
          variant="tonal"
          stroke="n"
          :disabled="select.length === 0"
          theme="secondary"
          rounded
          @click="handleClickDelete"
        >
          {{ $t('library.subscriber.popin.settings.save') }}
        </ButtonBase>
        <ButtonBase
          theme="secondary"
          class="stroke-n outlined"
          rounded
          @click="handleClickAdd"
        >
          {{ $t('library.subscriber.popin.settings.addNewContent') }}
        </ButtonBase>
      </div>
    </template>
  </DialogTemplate>
</template>
<script lang="ts" setup>
const dialog = useDialogStore();
const select = ref<string[]>([]);

const handleClickAdd = () => {
  dialog.close();
  navigateTo('/nomad');
};
const handleSelect = (id) => {
  const indexElt = select.value.indexOf(id);
  if (indexElt > -1) {
    select.value.splice(indexElt, 1);
  } else {
    select.value.push(id);
  }
};
const handleClickDelete = async () => {
  dialog.close();
  await useLibraryBooksRemoveFromProfile(select.value);
};

const contents = useContentsForUserType();

const items = computed(() => {
  return contents.all.value.map((item) => ({
    item,
    selected: select.value.includes(item.id),
  }));
});
</script>
<style lang="scss" scoped>
.settings-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 40vh;
  max-height: 40dvh;
  padding: 2rem 0;
  gap: 1rem;
  ul {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    width: 100%;
    padding: 0 2rem 0 0;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 0.5rem;
    }
    &::-webkit-scrollbar-thumb,
    &::-webkit-scrollbar-track {
      border-radius: 0.25rem;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--color_neutral_500);
    }

    &::-webkit-scrollbar-track {
      background: var(--color_neutral_100);
    }
  }
}
.hidden {
  opacity: 0.2;
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
